<script>
import LandingImageComponent from '@rei/landing-image-component';
import { LandingContentBlock } from '@rei/landing-content-block';
import BannerComponent from '@rei/banner-component';
import palettes from '../../mixins/palettes';

export default {
  name: 'LeadComponent',
  components: {
    LandingContentBlock,
    LandingImageComponent,
    BannerComponent,
  },
  mixins: [palettes],
  props: {
    media: { type: Object, required: false, default: () => null },
    content: { type: Object, required: false, default: () => {} },
    bannerComponentProps: { type: Object, required: false, default: () => {} },
  },
};
</script>
<template>
  <banner-component
    class="lead-component"
    v-bind="bannerComponentProps"
    :style="cssSurfacePaletteVars"
  >
    <template
      v-if="media"
      #background
    >
      <landing-image-component
        :lazy-load="false"
        v-bind="media"
        fetch-priority="high"
        data-ui="lead-component-media"
      />
    </template>
    <template
      v-if="content"
      #content
    >
      <landing-content-block
        data-ui="lead-component-content-block"
        v-bind="content"
      />
    </template>
  </banner-component>
</template>
<style lang="scss">
  @import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';
  .lead-component {
    background: var(--palette-background-color);
  }
  </style>
